import { render, staticRenderFns } from "./SpinnerCustom.vue?vue&type=template&id=7076e0f4&scoped=true&"
import script from "./SpinnerCustom.vue?vue&type=script&lang=js&"
export * from "./SpinnerCustom.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerCustom.vue?vue&type=style&index=0&id=7076e0f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7076e0f4",
  null
  
)

export default component.exports